import { useMediaQuery, useTheme } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Loading from "../Componentes/Loading"
import CardapioNovo from "./Cardapionovo"

export default function Cardapio() {
    const configs = useAppStore(s => s.configuracoes)
    const loading = useLoadingStore(s => s.loading)
    const estabelecimento = configs?.user?.parametros?.estabelecimento

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Container className="container-buscando">
            <Loading loading={loading} />

            <div
                style={{
                    textAlign: "center",
                    paddingTop: mobile ? "" : "4.8rem",
                    marginLeft: mobile ? "" : "80px",
                }}
            >
                {estabelecimento?.id ? <CardapioNovo estabelecimento={estabelecimento} /> : null}
            </div>
        </Container>
    )
}
